/* Match Glide Puck Optionize backing to the native Shopify Size selection. */
(()=>{
  'use strict';
  const config=document.getElementById('ihp-backing-size-config');if(!config)return;
  const data=JSON.parse(config.textContent);const norm=v=>String(v||'').trim().toLowerCase();
  const inches=v=>{const m=norm(v).match(/\b([23])\s*(?:inch|in\b|["″])/);return m?Number(m[1]):null;};
  let timer,syncing=false;
  function scope(){return document.querySelector('product-info[data-product-id="'+data.productId+'"]')||document.querySelector('product-info');}
  function puckSize(info){
    const picker=info.querySelector('variant-selects');
    const input=picker?.querySelector('input[data-option-name="Size"]:checked, select[name="options[Size]"]');
    if(input)return inches(input.value);
    const id=info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    return data.variants.find(v=>String(v.id)===id)?.size||null;
  }
  function sync(){
    if(syncing)return false;const info=scope();if(!info)return false;
    const size=puckSize(info);if(!size)return false;
    const raw=document.getElementById('optionize-option-set-'+data.productId);if(!raw)return false;
    const set=JSON.parse(raw.textContent);const option=set.options.find(o=>norm(o.name)==='product backing size');if(!option)return false;
    const row=[...info.querySelectorAll('.oz__option')].find(el=>norm(el.querySelector('.oz__option-label')?.textContent)===norm(option.label||option.name));
    let note=info.querySelector('[data-ihp-auto-size]');if(!note){note=document.createElement('p');note.dataset.ihpAutoSize='';note.className='caption';const form=info.querySelector('product-form');form?.before(note);}
    const text=`Backing automatically matches your ${size}-inch puck.`;if(note&&note.textContent!==text)note.textContent=text;
    if(!row)return true; // None selected: no backing-size option is needed.
    const value=option.values.find(v=>inches(v.label)===size);if(!value)return false;
    if(!row.classList.contains('ihp-auto-backing-size'))row.classList.add('ihp-auto-backing-size');
    const button=[...row.querySelectorAll('button')].find(b=>b.id===value.id);if(!button||button.disabled)return false;
    if(!button.classList.contains('oz__option-value--selected')){
      syncing=true;try{button.click();}finally{syncing=false;}schedule();return false;
    }
    return true;
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(sync,30);}
  document.addEventListener('change',e=>{if(e.target.closest('variant-selects'))schedule();});
  document.addEventListener('optionize-updated',schedule);
  document.addEventListener('click',e=>{
    if(!e.target.closest('product-info product-form button[name="add"]'))return;
    if(!sync()){
      e.preventDefault();e.stopImmediatePropagation();schedule();
      const note=scope()?.querySelector('[data-ihp-auto-size]');if(note)note.textContent='Matching backing to your puck. Please try Add to cart again.';
    }
  },true);
  document.addEventListener('submit',e=>{
    if(!e.target.closest('product-info')||!e.target.matches('form[action*="/cart/add"]'))return;
    if(!sync()){e.preventDefault();e.stopImmediatePropagation();schedule();}
  },true);
  const info=scope();if(info)new MutationObserver(schedule).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['class','value','checked']});
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.variantChange,schedule);
  schedule();
})();
